import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchShowcaseIndex } from '../../showcase/fetchShowcase'
import type { ShowcaseIndex } from '../../showcase/types'
import { ShowcaseShell } from './ShowcaseShell'

export function ShowcaseIndexPage() {
  const [index, setIndex] = useState<ShowcaseIndex | null>(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchShowcaseIndex()
      .then(setIndex)
      .catch((err) =>
        setError(err instanceof Error ? err.message : 'Failed to load showcase.'),
      )
      .finally(() => setLoading(false))
  }, [])

  return (
    <ShowcaseShell artistLabel="DISCOVER">
      {loading && (
        <p className="text-xs uppercase tracking-widest text-black/50 cursor-default">
          Loading…
        </p>
      )}
      {error && (
        <p className="text-xs uppercase tracking-widest text-red-700/90 cursor-default">
          {error}
        </p>
      )}
      {index && (
        <ul className="space-y-4">
          {index.artists.map((artist) => (
            <li key={artist.slug}>
              <Link
                to={`/showcase/${encodeURIComponent(artist.slug)}`}
                className="text-sm md:text-base uppercase tracking-wide text-black/80 hover:text-black border-b border-black/10 hover:border-black/40 pb-2 inline-block transition-colors"
              >
                {artist.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </ShowcaseShell>
  )
}
